// @flow

import {type RecordFactory, type RecordInstance, Map, Record} from 'immutable';

import {
  type RequestResponseMapType,
  setNormalizedList,
} from 'app/utils/redux_v2';

import {
  type KBCategoryActionType,
  RECEIVE_KB_CATEGORIES_LIST,
} from '../actions';
import {type KbCategoryType} from '../types';

type CategoryStateShape = RecordInstance<
  RequestResponseMapType<KbCategoryType>
>;

const CategoryStateFactory: RecordFactory<CategoryStateShape> = Record({
  byId: Map(),
  queries: Map(),
});

export type RecordOfKBCategoryState = RecordInstance<CategoryStateShape>;

export function kbCategoriesReducer(
  state: RecordOfKBCategoryState = CategoryStateFactory(),
  action: KBCategoryActionType
): RecordOfKBCategoryState {
  switch (action.type) {
    case RECEIVE_KB_CATEGORIES_LIST: {
      return setNormalizedList(action.query, action.response, state);
    }

    default:
      return state;
  }
}
